import { defineView } from "@/ReactSetup/view-definitions";

const definition = defineView({
    name: "TeaserList",
    component: () => (__SERVER__ ? require("./teaser-list-view") : import("./teaser-list-view"))
});

export default definition;
